export default "__VITE_ASSET__D_SfBEX7__"